// @generated by protoc-gen-es v2.15.0 with parameter "target=ts"
// @generated from file login_plataforma.proto (package sextante.seguridad.login_plataforma.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file login_plataforma.proto.
 */
export const file_login_plataforma: GenFile = /*@__PURE__*/
  fileDesc("ChZsb2dpbl9wbGF0YWZvcm1hLnByb3RvEiZzZXh0YW50ZS5zZWd1cmlkYWQubG9naW5fcGxhdGFmb3JtYS52MSI5ChZMb2dpblBsYXRhZm9ybWFSZXF1ZXN0Eg0KBWVtYWlsGAEgASgJEhAKCHBhc3N3b3JkGAIgASgJIiwKG0NoZWNrVG9rZW5QbGF0YWZvcm1hUmVxdWVzdBINCgV0b2tlbhgBIAEoCSItChxMb2dpblBvcnRhbFBsYXRhZm9ybWFSZXF1ZXN0Eg0KBXRva2VuGAEgASgJIqsCChdMb2dpblBsYXRhZm9ybWFSZXNwb25zZRINCgV0b2tlbhgBIAEoCRIOCgZub21icmUYAiABKAkSFwoPaGFzX3N1cGVyX2FkbWluGAMgASgIEhUKDWhhc19jb21lcmNpYWwYBCABKAgSFAoMaGFzX2hhcmR3YXJlGAUgASgIEhMKC2hhc19waWxvdG9zGAYgASgIEhcKD2hhc19jb25kdWN0b3JlcxgHIAEoCBITCgtoYXNfb2ZpY2luYRgIIAEoCBIXCgp0ZWNuaWNvX2lkGAkgASgJSACIAQESGAoLcHJvbW90b3JfaWQYCiABKAlIAYgBAUINCgtfdGVjbmljb19pZEIOCgxfcHJvbW90b3JfaWRKBAgLEAxSEGlzX3N1cGVyX3VzdWFyaW8y7QMKFkxvZ2luUGxhdGFmb3JtYVNlcnZpY2USkgEKD0xvZ2luUGxhdGFmb3JtYRI+LnNleHRhbnRlLnNlZ3VyaWRhZC5sb2dpbl9wbGF0YWZvcm1hLnYxLkxvZ2luUGxhdGFmb3JtYVJlcXVlc3QaPy5zZXh0YW50ZS5zZWd1cmlkYWQubG9naW5fcGxhdGFmb3JtYS52MS5Mb2dpblBsYXRhZm9ybWFSZXNwb25zZRKcAQoUQ2hlY2tUb2tlblBsYXRhZm9ybWESQy5zZXh0YW50ZS5zZWd1cmlkYWQubG9naW5fcGxhdGFmb3JtYS52MS5DaGVja1Rva2VuUGxhdGFmb3JtYVJlcXVlc3QaPy5zZXh0YW50ZS5zZWd1cmlkYWQubG9naW5fcGxhdGFmb3JtYS52MS5Mb2dpblBsYXRhZm9ybWFSZXNwb25zZRKeAQoVTG9naW5Qb3J0YWxQbGF0YWZvcm1hEkQuc2V4dGFudGUuc2VndXJpZGFkLmxvZ2luX3BsYXRhZm9ybWEudjEuTG9naW5Qb3J0YWxQbGF0YWZvcm1hUmVxdWVzdBo/LnNleHRhbnRlLnNlZ3VyaWRhZC5sb2dpbl9wbGF0YWZvcm1hLnYxLkxvZ2luUGxhdGFmb3JtYVJlc3BvbnNlQhaqAhNBcGkuR3JwYy5QbGF0YWZvcm1hYgZwcm90bzM");

/**
 * Credenciales de un usuario de Plataforma.
 *
 * @generated from message sextante.seguridad.login_plataforma.v1.LoginPlataformaRequest
 */
export type LoginPlataformaRequest = Message<"sextante.seguridad.login_plataforma.v1.LoginPlataformaRequest"> & {
  /**
   * @generated from field: string email = 1;
   */
  email: string;

  /**
   * @generated from field: string password = 2;
   */
  password: string;
};

/**
 * Describes the message sextante.seguridad.login_plataforma.v1.LoginPlataformaRequest.
 * Use `create(LoginPlataformaRequestSchema)` to create a new message.
 */
export const LoginPlataformaRequestSchema: GenMessage<LoginPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_login_plataforma, 0);

/**
 * Token de sesion que la app tiene guardado.
 *
 * @generated from message sextante.seguridad.login_plataforma.v1.CheckTokenPlataformaRequest
 */
export type CheckTokenPlataformaRequest = Message<"sextante.seguridad.login_plataforma.v1.CheckTokenPlataformaRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message sextante.seguridad.login_plataforma.v1.CheckTokenPlataformaRequest.
 * Use `create(CheckTokenPlataformaRequestSchema)` to create a new message.
 */
export const CheckTokenPlataformaRequestSchema: GenMessage<CheckTokenPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_login_plataforma, 1);

/**
 * Token JWT (RS256) que el portal de Nitria pone en la URL: /auth/verify-acount?token=...
 *
 * @generated from message sextante.seguridad.login_plataforma.v1.LoginPortalPlataformaRequest
 */
export type LoginPortalPlataformaRequest = Message<"sextante.seguridad.login_plataforma.v1.LoginPortalPlataformaRequest"> & {
  /**
   * @generated from field: string token = 1;
   */
  token: string;
};

/**
 * Describes the message sextante.seguridad.login_plataforma.v1.LoginPortalPlataformaRequest.
 * Use `create(LoginPortalPlataformaRequestSchema)` to create a new message.
 */
export const LoginPortalPlataformaRequestSchema: GenMessage<LoginPortalPlataformaRequest> = /*@__PURE__*/
  messageDesc(file_login_plataforma, 2);

/**
 * Sesion y roles del usuario de Plataforma. Cada has_* ya incluye al super usuario, que tiene todos los
 * permisos. Guid viaja como string.
 *
 * @generated from message sextante.seguridad.login_plataforma.v1.LoginPlataformaResponse
 */
export type LoginPlataformaResponse = Message<"sextante.seguridad.login_plataforma.v1.LoginPlataformaResponse"> & {
  /**
   * Token de sesion: la app lo manda en el header token de cada pedido.
   *
   * @generated from field: string token = 1;
   */
  token: string;

  /**
   * @generated from field: string nombre = 2;
   */
  nombre: string;

  /**
   * Rol administrador. Incluye al super usuario.
   *
   * @generated from field: bool has_super_admin = 3;
   */
  hasSuperAdmin: boolean;

  /**
   * Rol comercial.
   *
   * @generated from field: bool has_comercial = 4;
   */
  hasComercial: boolean;

  /**
   * Rol Soporte de la pantalla de usuarios.
   *
   * @generated from field: bool has_hardware = 5;
   */
  hasHardware: boolean;

  /**
   * Rol Piloto / Conductor: flota y vuelos.
   *
   * @generated from field: bool has_pilotos = 6;
   */
  hasPilotos: boolean;

  /**
   * Rol Piloto / Conductor: flota y vuelos.
   *
   * @generated from field: bool has_conductores = 7;
   */
  hasConductores: boolean;

  /**
   * Rol de oficina.
   *
   * @generated from field: bool has_oficina = 8;
   */
  hasOficina: boolean;

  /**
   * Tecnico asociado al usuario, si es tecnico de proyectos.
   *
   * @generated from field: optional string tecnico_id = 9;
   */
  tecnicoId?: string | undefined;

  /**
   * Promotor asociado al usuario, si es promotor.
   *
   * @generated from field: optional string promotor_id = 10;
   */
  promotorId?: string | undefined;
};

/**
 * Describes the message sextante.seguridad.login_plataforma.v1.LoginPlataformaResponse.
 * Use `create(LoginPlataformaResponseSchema)` to create a new message.
 */
export const LoginPlataformaResponseSchema: GenMessage<LoginPlataformaResponse> = /*@__PURE__*/
  messageDesc(file_login_plataforma, 3);

/**
 * Inicio de sesion de la SPA Plataforma. Logica propia del servicio gRPC, sin la capa vieja de servicios,
 * mismo criterio que LoginService del Cliente (ver login.proto). La sesion es un token JWT que vence al dia
 * y no se renueva. Estos rpc no requieren sesion.
 *
 * @generated from service sextante.seguridad.login_plataforma.v1.LoginPlataformaService
 */
export const LoginPlataformaService: GenService<{
  /**
   * Entrada con email y contrasena de un usuario de Plataforma. Devuelve un token de sesion nuevo y los roles
   * del usuario.
   *
   * @generated from rpc sextante.seguridad.login_plataforma.v1.LoginPlataformaService.LoginPlataforma
   */
  loginPlataforma: {
    methodKind: "unary";
    input: typeof LoginPlataformaRequestSchema;
    output: typeof LoginPlataformaResponseSchema;
  },
  /**
   * Valida la sesion guardada en cada carga de la app y devuelve los roles actuales con el mismo token.
   *
   * @generated from rpc sextante.seguridad.login_plataforma.v1.LoginPlataformaService.CheckTokenPlataforma
   */
  checkTokenPlataforma: {
    methodKind: "unary";
    input: typeof CheckTokenPlataformaRequestSchema;
    output: typeof LoginPlataformaResponseSchema;
  },
  /**
   * SSO desde el portal de Nitria, solo en la compilacion Nitrofert (decidido 2026-09-30, ver
   * Constantes.PortalNitria): valida el token que el portal manda en /auth/verify-acount y abre sesion para
   * el usuario de Plataforma con ese email, sin contrasena. Misma respuesta que LoginPlataforma. Todo rechazo
   * es InvalidArgument con el motivo para el usuario.
   *
   * @generated from rpc sextante.seguridad.login_plataforma.v1.LoginPlataformaService.LoginPortalPlataforma
   */
  loginPortalPlataforma: {
    methodKind: "unary";
    input: typeof LoginPortalPlataformaRequestSchema;
    output: typeof LoginPlataformaResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_login_plataforma, 0);

